(function () {
  const instances = new Map();

  function pauseAndPlay(videoEl) {
    if (!videoEl) return;
    videoEl.pause();
    const playPromise = videoEl.play();
    if (playPromise && typeof playPromise.catch === "function") {
      playPromise.catch(() => {});
    }
  }

  function switchMode(sectionEl, tabEl) {
    if (!sectionEl || !tabEl) return;

    const tabs = sectionEl.querySelectorAll("[data-jw1-s6-tab]");
    const modeNameEl = sectionEl.querySelector("[data-jw1-s6-mode-name]");
    const modeTargetEl = sectionEl.querySelector("[data-jw1-s6-mode-target]");
    const modePowerEl = sectionEl.querySelector("[data-jw1-s6-mode-power]");
    const videoEl = sectionEl.querySelector("[data-jw1-s6-video]");

    tabs.forEach((tab) => {
      const isActive = tab === tabEl;
      tab.classList.toggle("is-active", isActive);
      tab.setAttribute("aria-selected", isActive ? "true" : "false");
      tab.setAttribute("tabindex", isActive ? "0" : "-1");
    });

    if (modeNameEl) modeNameEl.textContent = tabEl.dataset.modeName || "";
    if (modeTargetEl) modeTargetEl.textContent = tabEl.dataset.modeTarget || "";
    if (modePowerEl) modePowerEl.textContent = tabEl.dataset.modePower || "";

    if (videoEl && tabEl.dataset.modeVideo) {
      const currentSource = videoEl.currentSrc || videoEl.getAttribute("src") || "";
      if (!currentSource.includes(tabEl.dataset.modeVideo)) {
        videoEl.src = tabEl.dataset.modeVideo;
        if (tabEl.dataset.modePoster) {
          videoEl.setAttribute("poster", tabEl.dataset.modePoster);
        } else {
          videoEl.removeAttribute("poster");
        }
        videoEl.load();
      }
      pauseAndPlay(videoEl);
    }
  }

  function bindSection(sectionEl) {
    const sectionId = sectionEl.dataset.sectionId;
    if (!sectionId) return;

    destroySection(sectionId);

    const tabs = sectionEl.querySelectorAll("[data-jw1-s6-tab]");
    const listeners = [];
    tabs.forEach((tabEl) => {
      const onClick = () => switchMode(sectionEl, tabEl);
      tabEl.addEventListener("click", onClick);
      listeners.push(() => tabEl.removeEventListener("click", onClick));
    });

    if (tabs[0]) {
      switchMode(sectionEl, tabs[0]);
    }

    instances.set(sectionId, { sectionEl, listeners });
  }

  function destroySection(sectionId) {
    const instance = instances.get(sectionId);
    if (!instance) return;
    instance.listeners.forEach((unbind) => unbind());
    instances.delete(sectionId);
  }

  function initAll() {
    document.querySelectorAll("[data-jw1-s6-section]").forEach((sectionEl) => {
      bindSection(sectionEl);
    });
  }

  function onBlockSelect(event) {
    const tabEl = event.target && event.target.closest ? event.target.closest("[data-jw1-s6-tab]") : null;
    if (!tabEl) return;

    const sectionEl = tabEl.closest("[data-jw1-s6-section]");
    if (!sectionEl) return;
    switchMode(sectionEl, tabEl);
  }

  document.addEventListener("DOMContentLoaded", initAll);

  document.addEventListener("shopify:section:load", (event) => {
    const sectionEl = event.target && event.target.closest ? event.target.closest("[data-jw1-s6-section]") : null;
    if (!sectionEl) return;
    bindSection(sectionEl);
  });

  document.addEventListener("shopify:section:unload", (event) => {
    const sectionEl = event.target && event.target.closest ? event.target.closest("[data-jw1-s6-section]") : null;
    if (!sectionEl) return;
    destroySection(sectionEl.dataset.sectionId);
  });

  document.addEventListener("shopify:block:select", onBlockSelect);
})();
